import React, { useState } from "react";
import "./Products.css";
import ABCMalt from "../../assets/Slider/ABC.jpg";
import PineapplePowder from "../../assets/Slider/pineapple-powder.jpg";
import BeetrootPowder from "../../assets/Slider/beet-root-powder.jpg";
import BananaPowder from "../../assets/Slider/powderbana.jpeg";
import MoringaPowder from "../../assets/Slider/moringaLeafPowder.jpg";
import GarlicPowder from "../../assets/Slider/Garlic-Powder.jpg";
import OnionPowder from "../../assets/Slider/Red-Onion-Powder.jpg";
import TurmericPowder from "../../assets/Slider/turmeric.jpg";
import CuminPowder from "../../assets/Slider/CuminPowder.jpg";
import BlackPepperPowder from "../../assets/Slider/black-pepper-powder.jpg";
import CorianderPowder from "../../assets/Slider/corri.jpg";
import FennelPowder from "../../assets/Slider/fennel.jpg";
import ChilliPowder from "../../assets/Slider/guntursanamchilli.jpg";

const products = [
  {
    title: "Onion Powder",
    HSNcode: "07122000",
    image: OnionPowder,
    description:
      "Onion Powder is a versatile spice made from dehydrated onions, finely ground to retain flavor, aroma, and nutritional value. It is widely used in culinary and food processing applications.",
    specs: {
      productName: "Onion Powder",
      botanicalName: "Allium cepa",
      appearance: "Fine, dry powder with a light beige to pale yellow color",
      flavor: "Strong pungent onion flavor and aroma",
      moisture: "Maximum 6%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "12 to 24 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage: "Store in cool, dry place away from sunlight",
      usage: "Used in seasonings, soups, sauces, snacks, and spice blends",
    },
  },
  {
    title: "ABC Malt",
    HSNcode: "38130000",
    image: ABCMalt,
    description:
      "ABC Malt is a nutritious health drink powder made from Apple, Beetroot, and Carrot extracts, blended with malt for enhanced taste and health benefits.",
    specs: {
      productName: "ABC Malt Health Drink",
      botanicalName: "Malus domestica / Beta vulgaris / Daucus carota",
      appearance: "Fine, free-flowing powder with reddish-brown color",
      flavor: "Mildly sweet, fruity taste with earthy undertones",
      moisture: "Maximum 5%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "12 to 18 months in cool, dry conditions",
      packaging:
        "Packed in food-grade moisture-proof containers or bags (200g / 500g / 1kg / bulk)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used as a health drink by mixing with milk or water, suitable for daily nutrition, energy support, and wellness diets",
    },
  },
  {
    title: "Moringa Powder",
    HSNcode: "12119029",
    image: MoringaPowder,
    description:
      "Moringa Powder is a nutrient-dense natural powder made from dried moringa leaves, widely used in food, nutraceutical, and herbal applications.",
    specs: {
      productName: "Moringa Leaf Powder",
      botanicalName: "Moringa oleifera",
      appearance: "Fine, dry powder with a vibrant green color",
      flavor: "Mild bitter, grassy taste with a natural herbal aroma",
      moisture: "Maximum 7%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "18 to 24 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in health supplements, herbal teas, smoothies, capsules, cosmetics, and functional foods",
    },
  },
  {
    title: "Garlic Powder",
    HSNcode: "07129020",
    image: GarlicPowder,
    description:
      "Garlic Powder is a finely ground spice made from dehydrated garlic cloves, known for its strong aroma, pungent flavor, and wide culinary applications.",
    specs: {
      productName: "Garlic Powder",
      botanicalName: "Allium sativum",
      appearance:
        "Fine, free-flowing powder with off-white to light yellow color",
      flavor: "Strong, pungent garlic flavor with characteristic aroma",
      moisture: "Maximum 6%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "24 to 36 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in seasoning blends, sauces, soups, marinades, snack foods, and food processing applications",
    },
  },
  {
    title: "Pineapple Powder",
    HSNcode: "21069099",
    image: PineapplePowder,
    description:
      "Pineapple Powder is a natural fruit powder made from fresh ripe pineapples, retaining the fruit’s characteristic flavor, aroma, and nutrients.",
    specs: {
      productName: "Pineapple Fruit Powder",
      botanicalName: "Ananas comosus",
      appearance: "Fine, free-flowing powder with light yellow to golden color",
      flavor: "Sweet-tangy pineapple flavor with natural fruity aroma",
      moisture: "Maximum 5%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "12 to 18 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in beverages, bakery products, confectionery, sauces, seasonings, and health supplements",
    },
  },
  {
    title: "Banana Powder",
    HSNcode: "08039010",
    image: BananaPowder,
    description:
      "Banana Powder is a natural, nutrient-rich product made from fresh ripe bananas, widely used in food, health, and baby food applications.",
    specs: {
      productName: "Banana Powder",
      botanicalName: "Musa paradisiaca",
      appearance: "Fine, dry powder with a light cream to pale yellow color",
      flavor: "Mild natural banana flavor with slight sweetness",
      moisture: "Maximum 5%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "12 to 18 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in baby food, bakery products, smoothies, health supplements, and confectionery",
    },
  },
  {
    title: "Beetroot Powder",
    HSNcode: "07129090",
    image: BeetrootPowder,
    description:
      "Beetroot Powder is a natural vegetable powder made from fresh beetroot, known for its rich color, nutrients, and health benefits.",
    specs: {
      productName: "Beetroot Powder",
      botanicalName: "Beta vulgaris",
      appearance:
        "Fine, free-flowing powder with deep red to reddish-purple color",
      flavor: "Mild earthy and slightly sweet beet flavor",
      moisture: "Maximum 6%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "12 to 24 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in health supplements, beverages, bakery products, natural food coloring, and nutraceutical formulations",
    },
  },
  {
    title: "Turmeric Powder",
    HSNcode: "09103030",
    image: TurmericPowder,
    description:
      "Turmeric Powder is a natural spice made from dried turmeric rhizomes, valued for its vibrant color, aroma, and high curcumin content.",
    specs: {
      productName: "Turmeric Powder",
      botanicalName: "Curcuma longa",
      appearance:
        "Fine, free-flowing powder with bright yellow to deep golden color",
      flavor: "Warm, slightly bitter, earthy taste with a strong aromatic note",
      moisture: "Maximum 8%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "24 to 36 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in culinary preparations, spice blends, food processing, nutraceuticals, cosmetics, and pharmaceutical applications",
    },
  },
  {
    title: "Cumin Powder",
    HSNcode: "09093200",
    image: CuminPowder,
    description:
      "Cumin Powder is a finely ground spice made from dried cumin seeds, known for its warm aroma, distinctive flavor, and digestive benefits.",
    specs: {
      productName: "Cumin Seed Powder",
      botanicalName: "Cuminum cyminum",
      appearance:
        "Fine, free-flowing powder with light brown to grayish-brown color",
      flavor:
        "Warm, earthy, slightly bitter taste with a strong aromatic profile",
      moisture: "Maximum 8%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "24 to 36 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in spice blends, culinary dishes, seasonings, sauces, and food processing applications",
    },
  },
  {
    title: "Black Pepper Powder",
    HSNcode: "09041190",
    image: BlackPepperPowder,
    description:
      "Black Pepper Powder is a finely ground spice made from dried black peppercorns, known as the ‘King of Spices’ for its strong aroma, pungency, and flavor.",
    specs: {
      productName: "Black Pepper Powder",
      botanicalName: "Piper nigrum",
      appearance: "Fine, free-flowing powder with dark brown to blackish color",
      flavor: "Strong, pungent, spicy taste with a sharp aromatic note",
      moisture: "Maximum 12%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "24 to 36 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in culinary dishes, spice blends, seasonings, sauces, meat processing, and food formulations",
    },
  },
  {
    title: "Chilli Powder",
    HSNcode: "09042211",
    image: ChilliPowder,
    description:
      "Chilli Powder is a finely ground spice made from dried red chillies, valued for its vibrant color, pungency, and heat level.",
    specs: {
      productName: "Red Chilli Powder",
      botanicalName: "Capsicum annuum",
      appearance: "Fine, free-flowing powder with bright red to deep red color",
      flavor: "Hot, pungent, and slightly smoky with a strong chilli aroma",
      moisture: "Maximum 10%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "24 to 36 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in culinary dishes, spice blends, sauces, pickles, food processing, and seasoning applications",
    },
  },
  {
    title: "Fennel Powder",
    HSNcode: "09096230",
    image: FennelPowder,
    description:
      "Fennel Powder is a finely ground spice made from dried fennel seeds, known for its sweet aroma, mild licorice-like flavor, and digestive properties.",
    specs: {
      productName: "Fennel Seed Powder",
      botanicalName: "Foeniculum vulgare",
      appearance:
        "Fine, free-flowing powder with light green to yellowish-brown color",
      flavor: "Sweet, aromatic, and mildly spicy with a licorice-like taste",
      moisture: "Maximum 10%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "24 to 36 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in spice blends, mouth fresheners, culinary dishes, herbal teas, and food processing applications",
    },
  },
  {
    title: "Coriander Powder",
    HSNcode: "09092200",
    image: CorianderPowder,
    description:
      "Coriander Powder is a finely ground spice made from dried coriander seeds, known for its mild citrusy aroma and warm, nutty flavor.",
    specs: {
      productName: "Coriander Seed Powder",
      botanicalName: "Coriandrum sativum",
      appearance:
        "Fine, free-flowing powder with light brown to yellowish-brown color",
      flavor: "Mild, slightly sweet, and citrusy with a warm aroma",
      moisture: "Maximum 10%",
      particleSize: "100% passing through 60 mesh",
      shelfLife: "24 to 36 months in cool, dry conditions",
      packaging: "Packed in food-grade moisture-proof bags (10kg / 25kg)",
      storage:
        "Store in a cool, dry place away from moisture and direct sunlight",
      usage:
        "Used in spice blends, curries, marinades, sauces, and food processing applications",
    },
  },
];

const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openModal = (product) => setSelectedProduct(product);
  const closeModal = () => setSelectedProduct(null);

  return (
    <div className="food-section">
      <h2 style={{ color: "#4CA1AF", fontSize: "36px", fontWeight: 700 }}>
        Our Products
      </h2>
      <div className="products-grid">
        {products.map((item, index) => (
          <div className="product-card" key={index}>
            <img src={item.image} alt={item.title} className="product-img" />

            <div className="product-content">
              <h3 className="product-title">{item.title}</h3>
              <p className="product-desc">{item.description}</p>

              <button className="read-more-btn" onClick={() => openModal(item)}>
                Read more
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedProduct && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-spec-box" onClick={(e) => e.stopPropagation()}>
            {/* Left - Image */}
            <div className="modal-left">
              <img
                src={selectedProduct.image}
                alt={selectedProduct.title}
                className="modal-spec-img"
              />
            </div>

            {/* Right - Details */}
            <div className="modal-right">
              <div className="title-row">
                <h2 className="modal-spec-title">{selectedProduct.title}</h2>

                <div className="hsn-box">
                  <strong>HSN Code :</strong> {selectedProduct.HSNcode}
                </div>
              </div>
              <ul className="spec-list">
                <li>
                  <strong>Product Name :</strong>{" "}
                  {selectedProduct.specs.productName}
                </li>
                <li>
                  <strong>Botanical Name :</strong>{" "}
                  {selectedProduct.specs.botanicalName}
                </li>
                <li>
                  <strong>Appearance :</strong>{" "}
                  {selectedProduct.specs.appearance}
                </li>
                <li>
                  <strong>Flavor & Aroma :</strong>{" "}
                  {selectedProduct.specs.flavor}
                </li>
                <li>
                  <strong>Moisture Content :</strong>{" "}
                  {selectedProduct.specs.moisture}
                </li>
                <li>
                  <strong>Particle Size :</strong>{" "}
                  {selectedProduct.specs.particleSize}
                </li>
                <li>
                  <strong>Shelf Life :</strong>{" "}
                  {selectedProduct.specs.shelfLife}
                </li>
                <li>
                  <strong>Packaging :</strong> {selectedProduct.specs.packaging}
                </li>
                <li>
                  <strong>Storage Conditions :</strong>{" "}
                  {selectedProduct.specs.storage}
                </li>
                <li>
                  <strong>Usage / Application :</strong>{" "}
                  {selectedProduct.specs.usage}
                </li>
              </ul>
            </div>

            {/* Close button */}
            <button className="modal-close" onClick={closeModal}>
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
